import { render, staticRenderFns } from "./TimetableSlidebar.vue?vue&type=template&id=ec95edf6"
import script from "./TimetableSlidebar.vue?vue&type=script&lang=js"
export * from "./TimetableSlidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports